import FICUtils from '../../common/general/js/FICUtils'
import FICValidator from '../../common/general/js/FICValidator'

const FICValidation = {}
export default FICValidation

FICValidation.itTaxCode = (value, allowVatNumbers = true) => {
  return FICUtils.controllaCF(value) === '' || (allowVatNumbers && FICUtils.controllaPIVA(value) === '')
}

FICValidation.itVatNumber = (value) => {
  return FICUtils.controllaPIVA(value) === ''
}

FICValidation.isEmail = (value) => {
  return FICValidator.email(value, true).valid
}



// WEBPACK FOOTER //
// ./src/common/validation-v2/validation.js